// extracted by mini-css-extract-plugin
export default {"root":"ItemName__root--12Qpq","edit":"ItemName__edit--1hNBa"};